import React from "react";
import { Redirect } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

//page
import Users from "../pages/Users";
import QuoteTag from "../pages/Quotes/tags";
import QuoteUniversal from "../pages/Quotes/universal";
import QuoteCountry from "../pages/Quotes/country";
import QuoteGeneral from "../pages/Quotes/general";
import Setting from "../pages/Setting";
import Notification from "../pages/Notification";
import HarmonyMood from "../pages/Harmony/Mood";
import SoundCat from "../pages/Harmony/Category";
import Sound from "../pages/Harmony/Sounds";
import Category from "../pages/Category";
import Language from "../pages/Language";
import KnowYourselfCat from "../pages/KnowYourself/Category";
import KnowYourself from "../pages/KnowYourself";
import KnowYourselfIntro from "../pages/KnowYourself/Intro";
import TalkIntro from "../pages/Talk/Intro";
import TalkCate from "../pages/Talk/Category";
import TalkQues from "../pages/Talk/Ques";
import Talk from "../pages/Talk";
import Plans from "../pages/Plans";
import Store from "../pages/ImageStore";
import LiveSession from "../pages/LiveSession";
import Podcast from "../pages/Podcast";
import PodcastRequest from "../pages/Podcast/Request";
import Banner from "../pages/Banner";
import TenderMaster from "../pages/category-master/AddTender";
import ViewTender from "../pages/category-master/ViewTender";
import JobMaster from "../pages/pdf-master/AddJob";
import ViewJob from "../pages/pdf-master/ViewJob";
// import NewsMaster from "../pages/news-master/AddNews";
// import ViewNews from "../pages/news-master/ViewNews";
import InquiryMaster from "../pages/inquiry-master";
// import LastUpdate from "../pages/last-update";
// import Calender from "../pages/calender";

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  // { path: '/dashboard2', component: Dashboard2 },
  { path: "/users", component: Users },
  // { path: "/quotes/tags", component: QuoteTag },
  // { path: "/quotes/universal", component: QuoteUniversal },
  // { path: "/quotes/country", component: QuoteCountry },
  // { path: "/quotes/general", component: QuoteGeneral },
  // { path: "/harmony_mood", component: HarmonyMood },
  // { path: "/harmony_category", component: SoundCat },
  // { path: "/harmony_sound", component: Sound },
  // { path: "/know-yourself-category", component: KnowYourselfCat },
  // { path: "/know-yourself-intro", component: KnowYourselfIntro },
  // { path: "/know-yourself-question", component: KnowYourself },
  // { path: "/category", component: Category },
  // { path: "/talk-intro", component: TalkIntro },
  // { path: "/talk-category", component: TalkCate },
  // { path: "/talk-ques", component: TalkQues },
  // { path: "/talks", component: Talk },
  // { path: "/live_session", component: LiveSession },
  // { path: "/podcast", component: Podcast },
  // { path: "/podcast_request", component: PodcastRequest },
  // { path: "/language", component: Language },
  // { path: "/plans", component: Plans },
  // { path: "/store", component: Store },
  // { path: "/banner", component: Banner },
  // { path: "/notification-data", component: NotificationData },
  // { path: "/setting", component: Setting },
  { path: "/add-category", component: TenderMaster },
  { path: "/view-category", component: ViewTender },
  { path: "/add-pdf", component: JobMaster },
  { path: "/view-pdf", component: ViewJob },
  // { path: "/news-master", component: NewsMaster },
  // { path: "/view-news", component: ViewNews },
  { path: "/contact-us", component: InquiryMaster },
  // { path: "/last-update", component: LastUpdate },
  // { path: "/calender", component: Calender },
  // { path: "/brand", component: Brand },
  // { path: "/category", component: Category },
  // { path: "/product", component: Product },
  // { path: "/property", component: Property },
  // { path: "/property/:id", component: Property },
  // { path: '/blog', component: Blog },

  //Notification
  { path: "/notification", component: Notification },
  // //profile
  { path: "/profile", component: UserProfile },

  // { path: "/panchang", component: Panchang },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  // { path: "/pages-404", component: Pages404 },
  // { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
];

export { userRoutes, authRoutes };
